module.exports = __webpack_public_path__ + "static/media/benedict-cover.a2f1863a.jpg";